import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "popcontainer-style2"
};
const _hoisted_2 = {
  class: "innerbox"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  class: "middlebox"
};
const _hoisted_5 = {
  key: 0,
  class: "imgbox fl"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "txtbox fl"
};
const _hoisted_8 = {
  key: 0,
  class: "namebox"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "inner"
};
const _hoisted_11 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Promotion = _resolveComponent("Promotion");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_button = _resolveComponent("el-button");
  return _ctx.$attrs.popshowflag && _ctx.$attrs.detail ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: "closediv",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.closePop && $options.closePop(...args))
  }, [...(_cache[2] || (_cache[2] = [_createElementVNode("span", {
    class: "icon-close"
  }, null, -1)]))]), _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$attrs.detail.title), 1), _createElementVNode("div", _hoisted_4, [_ctx.$attrs.detail.thumb.length ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("img", {
    src: _ctx.$attrs.detail.thumb[0].fileUrl,
    alt: ""
  }, null, 8, _hoisted_6)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [_createElementVNode("ul", null, [_createElementVNode("li", null, [_cache[3] || (_cache[3] = _createElementVNode("label", null, "级别：", -1)), _createElementVNode("span", null, _toDisplayString(_ctx.$attrs.detail.level), 1)]), _createElementVNode("li", null, [_cache[4] || (_cache[4] = _createElementVNode("label", null, "批次：", -1)), _createElementVNode("span", null, _toDisplayString(_ctx.$attrs.detail.batch), 1)]), _createElementVNode("li", null, [_cache[5] || (_cache[5] = _createElementVNode("label", null, "类别：", -1)), _createElementVNode("span", null, _toDisplayString(_ctx.$attrs.detail.category), 1)]), _createElementVNode("li", null, [_cache[6] || (_cache[6] = _createElementVNode("label", null, "传承人：", -1)), $data.person ? (_openBlock(), _createElementBlock("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.person, (item, index) => {
    return _openBlock(), _createElementBlock("a", {
      onClick: $event => $options.showperson(item.itemformdata.detailUrl)
    }, _toDisplayString(item.itemformdata.name), 9, _hoisted_9);
  }), 256))])) : _createCommentVNode("", true)])])])]), _cache[8] || (_cache[8] = _createElementVNode("div", {
    class: "descbox"
  }, [_createElementVNode("div", {
    class: "richtext",
    id: "editor1"
  })], -1)), $data.routeflag && _ctx.$attrs.detail.correlation_address.length > 0 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "icon-position",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.goLocation && $options.goLocation(...args))
  }, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Promotion)]),
    _: 1
  }), _cache[7] || (_cache[7] = _createElementVNode("span", null, "导航", -1))])])) : _createCommentVNode("", true)]), _withDirectives(_createElementVNode("iframe", {
    id: "popiframe",
    src: $data.iframeurl,
    frameborder: "0"
  }, null, 8, _hoisted_11), [[_vShow, $data.linkcontainerflag]]), _withDirectives(_createVNode(_component_el_button, {
    class: "goback",
    onClick: $options.goback,
    round: ""
  }, {
    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("返回", -1)]))]),
    _: 1
  }, 8, ["onClick"]), [[_vShow, $data.linkcontainerflag]])])) : _createCommentVNode("", true);
}